import { put, call, all, fork, select, takeLatest, takeEvery } from "redux-saga/effects";
import {
  usersApiUpsellProvider,
  clientsApiProvider,
  userApiProvider,
  servicesApiUpsellProvider,
  aclApiUsellProvider,
  rolesApiUpsellProvider,
  sectorsApiUpsellProvider
} from "../../lib/api/providers";

import {
  USER_SET_FILTERS,
  USER_FILTERS_LOADING,
  USER_SET_USERS,
  USER_USERS_LOADING,
  USER_SET_PAGINATION,
  USER_SET_CURRENT_FILTERS,
  USER_GET_DYNAMIQUE_FILTER_VALUES,
  USER_SET_SORT,
  USER_SET_KEY_FILTER_SELECTED,
  USER_GET_ALL_CLIENTS,
  USER_SET_ALL_CLIENTS,
  UPDATE_USER_CLIENTS,
  GET_SERVICES_LIST,
  SET_SERVICES_LIST,
  GET_ACL_LIST,
  SET_ACL_LIST,
  UPDATE_ACL_SERVICE_CLIENT,
  UPDATE_USERS_LIST,
  GET_ROLES_LIST,
  SET_ROLES_LIST,
  UPDATE_USER_ROLE,
  UPDATE_USER_SECTOR,
  USER_GET_SECTORS_LIST,
  USER_SET_SECTORS_LIST,
  SECTORS_UPDATE_LIST,
  USER_UPDATE_LOADING,
  UPDATE_USER_KPIS,
  SET_CURRENT_USER_INFOS
} from "../types";
import _ from "lodash";
import { currentClientSelector } from "../selectors/auth";

const getUserState = state => state.user;
const getAuthState = state => state.auth;
const getState = state => state;

const getAclApi = () => {
  return aclApiUsellProvider.post(`/`, {}).then(response => {
    return response.data;
  });
};

export const getServicesApi = (filters = {}) => {
  return servicesApiUpsellProvider.post(`/`, filters).then(response => {
    return response.data;
  });
};

const getUserSectorsListApi = (stateAuth, state) => {
  return sectorsApiUpsellProvider
    .post(
      "/",
      {
        match: {
          client_id: state.currentClient.id
        },
        project: {
          sector_id: 1,
          sector_label: 1
        }
      },
      {
        headers: {
          Authorization: stateAuth.token
        }
      }
    )
    .then((response = {}) => response.data);
};

const getFiltersValuesApi = (state, stateAuth) => {
  const currentFiltersToSend = { ...state.currentFilters };
  delete currentFiltersToSend[state.keyFilterSelected];
  return usersApiUpsellProvider
    .post(
      `/distincts/${state.keyFilterSelected}`,
      {
        match: currentFiltersToSend
      },
      {
        headers: {
          Authorization: stateAuth.token
        }
      }
    )
    .then((response = {}) => {
      return response.data;
    });
};

const getClientsApi = () => {
  return clientsApiProvider.post(`/`, {}).then(response => {
    return response.data;
  });
};

const getRolesApi = () => {
  return rolesApiUpsellProvider.post(`/`, {}).then(response => {
    return response.data;
  });
};

const getUsersApi = (state, stateAuth) => {
  return usersApiUpsellProvider
    .post(
      `/`,
      {
        match: state.currentFilters ? state.currentFilters : {},
        sort: state.sort,
        page: state.page > 0 ? state.page : 1,
        pageSize: state.pageSize
      },
      {
        headers: {
          Authorization: stateAuth.token
        }
      }
    )
    .then((response = {}) => {
      return response.data;
    });
};

const getUsersUpdatedRoleApi = (action, stateAuth) => {
  const { userId, roleId } = action.data;

  return userApiProvider
    .post(
      `/${userId}/changeRole`,
      {
        role_id: roleId
      },
      {
        headers: {
          Authorization: stateAuth.token
        }
      }
    )
    .then((response = {}) => {
      return response.data;
    });
};

const getUserClientsUpdateApi = (action, stateAuth) => {
  const actionUrl = action.data.status ? "addClient" : "removeClient";
  const user_id = action.data.userId;

  return userApiProvider
    .post(
      `/${user_id}/${actionUrl}`,
      {
        client_id: action.data.clientId
      },
      {
        headers: {
          Authorization: stateAuth.token
        }
      }
    )
    .then((response = {}) => {
      return response.data;
    });
};
const getUserKpisUpdateApi = (action, stateAuth) => {
  const actionUrl = action.data.status ? "addKpi" : "removeKpi";
  const user_id = action.data.userId;
  return userApiProvider
    .post(
      `/${user_id}/${actionUrl}`,
      {
        kpi_id: action.data.kpiId
      },
      {
        headers: {
          Authorization: stateAuth.token
        }
      }
    )
    .then((response = {}) => {
      return response.data;
    });
};

const getUsersUpdatedSectorApi = (action, currentClient) => {
  const actionUrl = action.data.status ? "addSector" : "removeSector";
  const user_id = action.data.userId;

  return userApiProvider
    .post(`/${user_id}/${actionUrl}`, {
      sector_id: action.data.sectorId,
      client_id: currentClient.id
    })
    .then((response = {}) => {
      return response.data;
    });
};

const getUsersUpdatedAclServiceClientApi = (action, stateAuth) => {
  const { userId, clientId, serviceId, attribut, status } = action.data;
  return userApiProvider
    .post(
      `/${userId}/client/${clientId}/service/${serviceId}/changeACL`,
      {
        [attribut]: status ? 1 : 0
      },
      {
        headers: {
          Authorization: stateAuth.token
        }
      }
    )
    .then((response = {}) => {
      return response.data;
    });
};

function* getUsersUpdatedAclServiceClient(action) {
  try {
    const state = yield select(getUserState);
    const stateAuth = yield select(getAuthState);
    const data = yield call(getUsersUpdatedAclServiceClientApi, action, stateAuth);

    const dataUserAclServiceClientUpdated = state.users.map(user => (user._id === data._id ? data : user));

    yield put({
      type: UPDATE_USERS_LIST,
      payload: dataUserAclServiceClientUpdated
    });
  } catch (e) {
    console.log(e.message);
  }
}

function* getUsersUpdatedClients(action) {
  try {
    const state = yield select(getUserState);
    const stateAuth = yield select(getAuthState);
    const data = yield call(getUserClientsUpdateApi, action, stateAuth);
    const dataUserClientUpdated = state.users.map(user => (user._id === data._id ? data : user));

    yield put({ type: UPDATE_USERS_LIST, payload: dataUserClientUpdated });
  } catch (e) {
    console.log(e.message);
  }
}
function* getUsersUpdatedKpis(action) {
  try {
    const stateUser = yield select(getUserState);
    const state = yield select(getState);
    const stateAuth = yield select(getAuthState);
    const data = yield call(getUserKpisUpdateApi, action, stateAuth);
    let currentUserIsSelected = false;
    const dataUserKpiUpdated = stateUser.users.map(user => {
      if (user._id === data._id && user._id === state.userInfos._id) currentUserIsSelected = data;

      return user._id === data._id ? data : user;
    });

    yield put({ type: UPDATE_USERS_LIST, payload: dataUserKpiUpdated });
    if (currentUserIsSelected) {
      // yield put({ type: SET_CURRENT_USER_INFOS, payload: data });
    }
  } catch (e) {
    console.log(e.message);
  }
}

function* getUsers() {
  try {
    yield put({ type: USER_USERS_LOADING, loading: true });
    const state = yield select(getUserState);
    const stateAuth = yield select(getAuthState);
    const data = yield call(getUsersApi, state, stateAuth);
    if (!Array.isArray(data.docs)) {
      throw new Error("No users");
    }
    data.email = [data.email];
    yield put({ type: USER_SET_USERS, payload: data });
    yield put({ type: USER_USERS_LOADING, loading: false });
  } catch (e) {
    console.log(e.message);
    yield put({ type: USER_USERS_LOADING, loading: false });
  }
}

function* getFiltersValues() {
  try {
    yield put({ type: USER_FILTERS_LOADING, loading: true });
    const state = yield select(getUserState);
    const stateAuth = yield select(getAuthState);
    let values = [];
    if (
      state.keyFilterSelected === "email" ||
      state.keyFilterSelected === "fullName" ||
      state.keyFilterSelected === "lucca_legal_entity_name" ||
      state.keyFilterSelected === "lucca_manager_name" ||
      state.keyFilterSelected === "lucca_department_name" ||
      state.keyFilterSelected === "effectif"
    ) {
      values = yield call(getFiltersValuesApi, state, stateAuth);
    }
    if (state.keyFilterSelected === "role") values = state.rolesDistinct;
    if (state.keyFilterSelected === "clients") values = state.clientsDistinct;
    if (values.length <= 0) {
      throw new Error("No filters");
    }
    yield put({
      type: USER_SET_FILTERS,
      values: values,
      key: state.keyFilterSelected
    });
    yield put({ type: USER_FILTERS_LOADING, loading: false });
  } catch (e) {
    console.log(e.message);
    yield put({ type: USER_FILTERS_LOADING, loading: false });
  }
}

function* getAllClients() {
  try {
    const data = yield call(getClientsApi);
    const dataFiltered = data.filter(data => data.label);

    yield put({ type: USER_SET_ALL_CLIENTS, payload: dataFiltered });
  } catch (e) {
    console.log(e.message);
  }
}

function* getServiceList() {
  try {
    const data = yield call(getServicesApi);

    yield put({ type: SET_SERVICES_LIST, payload: data });
  } catch (e) {
    console.log(e.message);
  }
}

function* getAclList() {
  try {
    const data = yield call(getAclApi);

    yield put({ type: SET_ACL_LIST, payload: data });
  } catch (e) {
    console.log(e.message);
  }
}

function* getRolesList() {
  try {
    let data = yield call(getRolesApi);

    yield put({ type: SET_ROLES_LIST, payload: data });
  } catch (e) {
    console.log(e.message);
  }
}

function* getUsersUpdatedRole(action) {
  try {
    const state = yield select(getUserState);
    const stateAuth = yield select(getAuthState);
    const data = yield call(getUsersUpdatedRoleApi, action, stateAuth);
    const dataUserAclServiceClientUpdated = state.users.map(user => (user._id === data._id ? data : user));

    yield put({
      type: UPDATE_USERS_LIST,
      payload: dataUserAclServiceClientUpdated
    });
  } catch (e) {
    console.log(e.message);
  }
}

function* getUsersUpdatedSector(action) {
  try {
    yield put({ type: USER_UPDATE_LOADING, payload: true });
    const userState = yield select(getUserState);
    const state = yield select(getState);
    const currentClient = yield select(currentClientSelector);
    const data = yield call(getUsersUpdatedSectorApi, action, currentClient);

    if (action.page === "users") {
      const dataUserSectorUpdated = userState.users.map(user => (user._id === data._id ? data : user));

      yield put({ type: UPDATE_USERS_LIST, payload: dataUserSectorUpdated });
    } else if (action.page === "sectors") {
      let dataSectorsUserSectorUpdate = [];
      dataSectorsUserSectorUpdate = state.sectors.sectorsList.map(sector => {
        const sectorCopy = _.cloneDeep(sector);

        if (sector.sector_id === action.data.sectorId) {
          if (action.data.status) sectorCopy.users.push(data);
          else if (!action.data.status) {
            sector.users.forEach((user, index) => {
              if (user._id === data._id) sectorCopy.users.splice(index, 1);
            });
          }
        }
        return sectorCopy;
      });
      yield put({
        type: SECTORS_UPDATE_LIST,
        payload: dataSectorsUserSectorUpdate
      });
    }
    yield put({ type: USER_UPDATE_LOADING, payload: false });
  } catch (e) {
    console.log(e.message);
    yield put({ type: USER_UPDATE_LOADING, payload: false });
  }
}

function* getUserSectorsList() {
  try {
    const stateAuth = yield select(getAuthState);
    const state = yield select(getState);
    const data = yield call(getUserSectorsListApi, stateAuth, state);

    yield put({ type: USER_SET_SECTORS_LIST, payload: data });
  } catch (e) {
    console.log(e.message);
  }
}

function* watchFecthUsers() {
  yield takeLatest(USER_SET_CURRENT_FILTERS, getUsers);
}

function* watchFetchUsersPagination() {
  yield takeLatest(USER_SET_PAGINATION, getUsers);
}

function* wathFetchDynFilterValues() {
  yield takeLatest(USER_GET_DYNAMIQUE_FILTER_VALUES, getFiltersValues);
}

function* watchSetKeyFilterSelected() {
  yield takeLatest(USER_SET_KEY_FILTER_SELECTED, getFiltersValues);
}

function* watchSortUsers() {
  yield takeLatest(USER_SET_SORT, getUsers);
}

function* watchSetAllClients() {
  yield takeLatest(USER_GET_ALL_CLIENTS, getAllClients);
}

function* watchUpdateUserClients() {
  yield takeLatest(UPDATE_USER_CLIENTS, getUsersUpdatedClients);
}
function* watchUpdateUserKpis() {
  yield takeLatest(UPDATE_USER_KPIS, getUsersUpdatedKpis);
}

function* watchGetServicesList() {
  yield takeLatest(GET_SERVICES_LIST, getServiceList);
}

function* watchGetAclList() {
  yield takeLatest(GET_ACL_LIST, getAclList);
}

function* watchUpdateAclServiceClient() {
  yield takeLatest(UPDATE_ACL_SERVICE_CLIENT, getUsersUpdatedAclServiceClient);
}

function* watchGetRolesList() {
  yield takeLatest(GET_ROLES_LIST, getRolesList);
}

function* watchUpdateUserRole() {
  yield takeLatest(UPDATE_USER_ROLE, getUsersUpdatedRole);
}

function* watchUpdateUserSector() {
  yield takeEvery(UPDATE_USER_SECTOR, getUsersUpdatedSector);
}

function* watchGetUserSectorsList() {
  yield takeLatest(USER_GET_SECTORS_LIST, getUserSectorsList);
}

export default function* root() {
  yield all([
    fork(watchFetchUsersPagination),
    fork(watchFecthUsers),
    fork(wathFetchDynFilterValues),
    fork(watchSortUsers),
    fork(watchSetKeyFilterSelected),
    fork(watchSetAllClients),
    fork(watchUpdateUserClients),
    fork(watchGetServicesList),
    fork(watchGetAclList),
    fork(watchUpdateAclServiceClient),
    fork(watchGetRolesList),
    fork(watchUpdateUserRole),
    fork(watchUpdateUserSector),
    fork(watchGetUserSectorsList),
    fork(watchUpdateUserKpis)
  ]);
}



// WEBPACK FOOTER //
// src/redux/sagas/userSagas.js